import React from 'react';
import _get from 'lodash/get';
import { useFormikContext } from 'formik';
import { HiMiniMapPin } from 'react-icons/hi2';

import LocationPicker from './LocationPicker';
import classNames from 'classnames';
import Error from './Error';

const FIELD_NAME = 'address';

const Location = () => {
  const { errors, touched, values } = useFormikContext<any>();

  const showError = !!_get(errors, FIELD_NAME) && !!_get(touched, FIELD_NAME);

  return (
    <>
      <div
        className={classNames(
          'mt-6 text-base placeholder:text-gray-500 flex items-center w-full rounded-md font-normal',
          {
            'bg-red-100 p-1': showError
          }
        )}
      >
        <HiMiniMapPin size={24} className="mr-2 text-gray-500" />
        <LocationPicker
          name="address"
          className="text-base font-normal w-full bg-transparent"
          locationFieldName="address"
          placeholder="Where will this take place?*"
          initialValue={{
            address: values.address,
            coordinates: values.coordinates
          }}
          coordinatesFieldName="coordinates"
          showCurrentLocationButton={false}
        />
      </div>
      {showError && <Error error={_get(errors, FIELD_NAME)} />}
    </>
  );
};

export default Location;
